import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopAddressFragmentDoc } from './shop-user.gql.generated';
import { ShopGeoRegionDetailFragmentDoc } from './shop-region.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopCollectionPointFragment = { __typename: 'ShopCollectionPointObject', id: number, name: string, address: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined, region?: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> } | null | undefined } };

export type ShopCollectionPointsQueryVariables = Types.Exact<{
  channelCode: Types.Scalars['String']['input'];
  shippingMethodId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  searchText?: Types.InputMaybe<Types.Scalars['String']['input']>;
  coordinates?: Types.InputMaybe<Types.ShopPointInput>;
  page?: Types.InputMaybe<Types.ShopPageInput>;
  sort?: Types.InputMaybe<Types.ShopSortInput>;
}>;


export type ShopCollectionPointsQuery = { __typename: 'Query', totalItemsCount: number, items: Array<{ __typename: 'ShopCollectionPointObject', id: number, name: string, address: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined, region?: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> } | null | undefined } }> };

export const ShopCollectionPointFragmentDoc = gql`
    fragment ShopCollectionPoint on ShopCollectionPointObject {
  id
  name
  address {
    ...ShopAddress
    region {
      ...ShopGeoRegionDetail
    }
  }
}
    ${ShopAddressFragmentDoc}
${ShopGeoRegionDetailFragmentDoc}`;
export const ShopCollectionPointsDocument = gql`
    query ShopCollectionPoints($channelCode: String!, $shippingMethodId: Int, $searchText: String, $coordinates: ShopPointInput, $page: ShopPageInput, $sort: ShopSortInput) {
  items: shopCollectionPoints(
    channelCode: $channelCode
    shippingMethodId: $shippingMethodId
    searchText: $searchText
    coordinates: $coordinates
    page: $page
    sort: $sort
  ) {
    ...ShopCollectionPoint
  }
  totalItemsCount: shopCollectionPointsCount(
    channelCode: $channelCode
    shippingMethodId: $shippingMethodId
    searchtext: $searchText
  )
}
    ${ShopCollectionPointFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCollectionPointsGQL extends Apollo.Query<ShopCollectionPointsQuery, ShopCollectionPointsQueryVariables> {
    document = ShopCollectionPointsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }